<template>
  <div class="wrapper" v-if="userData" tabindex="0">
    <div class="wrapper__content" id="wrapper">
      <h1>Soli-Ersparnis</h1>
      <h2>2021 fällt der Soli für die meisten Bürger weg. Ermitteln Sie hier Ihre Ersparnis.</h2>

      <!-- Formular -->
      <stepper v-if="!soliBerechnet"
               :stepItems="stepItems"
               :active-step="activeTab"
               @change-tab="changeActiveTab"
               @submit-form="calcSoliErsparnis">

        <template v-slot:tab1>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  Persönliche Verhältnisse
<!--                  <tooltip text="Beispieltext für Ihr Tooltip"></tooltip>-->
                </span>

                <toggle-switch
                  toggle-on-label="ledig"
                  toggle-off-label="verheiratet"
                  toggle-on-value="ledig"
                  toggle-off-value="verheiratet"
                  :selected=userData.relationShipStatus
                  id="relationship"
                  name="relationship"
                  @input="setRelationShipStatus($event)">
                </toggle-switch>
              </div>
            </div>
            <div class="col-6" v-if="userData.relationShipStatus !== 'ledig'">
              <div class="form-group">
                <span class="form-group__headline">
                  Gemeinsame Veranlagung
                  <tooltip text="Bei der Zusammenveranlagung wird der Gesamtbetrag beider Einkünfte gemeinsam ermittelt.
                  Die Ehegatten werden zusammen wie ein einziger Steuerpflichtiger behandelt.
                  Die Einkommensteuer wird für die Hälfte der Einkünfte berechnet und die so errechnete Steuer wird dann
                  verdoppelt (Ehegattensplitting)."></tooltip>
                </span>

                <toggle-switch
                  toggle-on-label="ja"
                  toggle-off-label="nein"
                  :toggle-on-value=true
                  :toggle-off-value=false
                  :selected=userData.cashSplitting
                  id="cashSplitting"
                  name="cashSplitting"
                  @input="setCashSplitting($event)"></toggle-switch>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  Kinder
                </span>

                <toggle-switch
                  toggle-on-label="nein"
                  toggle-off-label="ja"
                  :toggle-on-value=false
                  :toggle-off-value=true
                  :selected=userData.hasKids
                  id="kids"
                  name="kids"
                  @input="setKids($event)"></toggle-switch>
              </div>
            </div>
            <div class="col-6" v-if="userData.hasKids === true">
              <div class="form-group">
                <span class="form-group__headline">
<!--                  Kinderfreibetrag-->
<!--                  <tooltip text="Bei unverheirateten Eltern wird der Betrag aufgeteilt, sodass jedes Elternteil einen-->
<!--                  halben Kinderfreibetrag pro Kind nutzen kann. Verheiratete können ihn bei Zusammenveranlagung in-->
<!--                  voller Höhe gemeinsam nutzen.-->

<!--                  Kinderfreibetrag und Kindergeld sind zwei Varianten, um Familien mit Kindern finanziell zu fördern.-->
<!--                  Sie können entweder nur das Kindergeld oder den Kinderfreibetrag nutzen.-->
<!--                  Erst ab einem bestimmten Einkommen ist der Kinderfreibetrag bei der Berechnung der zu zahlenden Steuer-->
<!--                  günstiger. Welche Variante für Sie besser ist, wird in der späteren Berechnung mit der-->
<!--                  sogenannten Günstigerprüfung automatisch geprüft."></tooltip>-->

                  Anzahl der Kinder
                </span>
<!--                <vf-input-select-->
<!--                  id="kidsFreeAmountList"-->
<!--                  name="kidsFreeAmountList"-->
<!--                  :selected=userData.kidsFreeAmount-->
<!--                  @input="setKidsFreeAmount($event)">-->

<!--                  <option value="0">0</option>-->
<!--                  <option value="0.5">0,5</option>-->
<!--                  <option value="1">1</option>-->
<!--                  <option value="1.5">1,5</option>-->
<!--                  <option value="2">2</option>-->
<!--                  <option value="2.5">2,5</option>-->
<!--                  <option value="3">3</option>-->
<!--                  <option value="3.5">3,5</option>-->
<!--                  <option value="4">4</option>-->
<!--                  <option value="4.5">4,5</option>-->
<!--                  <option value="5">5</option>-->
<!--                  <option value="5.5">5,5</option>-->
<!--                </vf-input-select>-->

                <vf-input-select
                  id="kidsList"
                  name="kidsList"
                  :selected=userData.sumOfKids
                  @input="setSumOfKids($event)">

                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </vf-input-select>
              </div>
            </div>
          </div>
          <div class="row" v-if="userData.hasKids === true && userData.relationShipStatus === 'ledig'">
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  Alleinerziehend
                </span>

                <toggle-switch
                  toggle-on-label="nein"
                  toggle-off-label="ja"
                  :toggle-on-value=false
                  :toggle-off-value=true
                  :selected=userData.isSingleParent
                  id="isSingleParent"
                  name="isSingleParent"
                  @input="setSingleParent($event)"></toggle-switch>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  Bundesland
                </span>
                <vf-input-select
                  id="state"
                  name="state"
                  :selected=userData.state
                  @input="e => userData.state = e">

                  <option value="bw">Baden-Württemberg</option>
                  <option value="by">Bayern</option>
                  <option value="be">Berlin</option>
                  <option value="bb">Brandenburg</option>
                  <option value="hb">Bremen</option>
                  <option value="hh">Hamburg</option>
                  <option value="he">Hessen</option>
                  <option value="mv">Mecklenburg-Vorpommern</option>
                  <option value="ni">Niedersachen</option>
                  <option value="nrw">Nordrhein-Westfalen</option>
                  <option value="rp">Rheinland-Pfalz</option>
                  <option value="sl">Saarland</option>
                  <option value="sn">Sachsen</option>
                  <option value="st">Sachsen-Anhalt</option>
                  <option value="sh">Schleswig-Holstein</option>
                  <option value="th">Thüringen</option>
                </vf-input-select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  Kirchensteuer
                </span>

                <toggle-switch
                  toggle-on-label="ja"
                  toggle-off-label="nein"
                  :toggle-on-value=true
                  :toggle-off-value=false
                  :selected=userData.churchTax
                  id="churchTax"
                  name="churchTax"
                  @input="e => userData.churchTax = JSON.parse(e)"></toggle-switch>

              </div>
            </div>
          </div>
        </template>
        <template v-slot:tab2>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  jährliches Brutto Gehalt
                  <span v-if="userData.relationShipStatus === 'verheiratet' && userData.cashSplitting">Ehepaar</span>
                  <tooltip text="Bitte geben Sie hier Ihre jährlichen Bruttoeinkünfte aus nicht selbstständiger Arbeit,
                      zuzüglich sonstiger steuerpflichtiger Zuwendungen, an.
                      Davon dürfen alle Ausgaben, die für die Erzielung der Einkünfte notwendig waren, vorab abgezogen werden.
                      Ausgenommen Werbungskosten, diese werden im Schritt Freibeträge berücksichtigt.
                      Falls Sie Ehegattensplitting mit 'ja' beantworten, geben Sie bitte auch die entsprechenden Einkünfte des Partners an.">
                  </tooltip>
                </span>
                <vf-input v-model.number="formattedBrutto" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showIncomeAgrarInput">
                <span class="form-group__headline">
                  Einkünfte aus Landwirtschaft
                  <tooltip text="Einkünfte aus dem Betrieb von Landwirtschaft, Forstwirtschaft, Weinbau, Gartenbau,
                  Baumschulen und aus allen Betrieben, die Pflanzen und Pflanzenteile mit Hilfe der Naturkräfte gewinnen.">
                  </tooltip>
                </span>
                <vf-input v-model.number="formattedAgrar" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showIncomeCommerceInput">
                <span class="form-group__headline">
                  Einkünfte aus Gewerbebetrieb
                  <tooltip text="Einkünfte aus gewerblichen Unternehmen, auch Gewinnanteile der Gesellschafter von
                  Personengesellschaften, Gewinnanteile der persönlich haftenden Gesellschafter einer Kommanditgesellschaft
                  auf Aktien, Einkünfte einer gewerblich geprägten Personengesellschaft, Veräußerungsgewinne
                  (Betriebsaufgabe, Betriebsveräußerung, Beteiligungsveräußerung).">
                  </tooltip>
                </span>
                <vf-input v-model.number="formattedCommerce" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showIncomeIndependentWorkInput">
                <span class="form-group__headline">
                  Einkünfte aus selbstständiger Arbeit
                  <tooltip text="Einkünfte aus selbständiger Arbeit bzw. Einkünfte aus freiberuflicher Tätigkeit.">
                  </tooltip>
                </span>
                <vf-input v-model.number="formattedIndependentWork" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showIncomeCapitalInput">
                <span class="form-group__headline">
                  Einkünfte aus Kapitalvermögen
                  <tooltip text="Einkünfte aus Kapitalvermögen, die der Abgeltungssteuer unterliegen. Zu den Einkünften
                  aus Kapitalvermögen gehören unter anderem Gewinnausschüttungen, Zinsen und Dividenden, wenn sich die Vermögenssubstanz,
                  aus der diese Einnahmen erzielt werden, im Privatvermögen befindet.">
                  </tooltip>
                </span>
                <vf-input v-model.number="formattedCapital" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showIncomeRentInput">
                <span class="form-group__headline">
                  Einkünfte aus Vermietung
                  <tooltip text="Gewinne aus der Vermietung oder Verpachtung von Häusern, Wohnungen oder sonstigen Immobilien.">
                  </tooltip>
                </span>
                <vf-input v-model.number="formattedRent" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showIncomeOtherInput">
                <span class="form-group__headline">
                  Sonstige Einkünfte
                  <tooltip text="Sonstige steuerpflichtige Einkünfte.">
                  </tooltip>
                </span>
                <vf-input v-model.number="formattedOther" type="number" suffix="€"></vf-input>
              </div>

              <dropdown :is-open="showIncomeDropdownIsOpen" v-if="showIncomeDropdown">
                <template v-slot:target>
                  <button  @click="showIncomeDropdownIsOpen = !showIncomeDropdownIsOpen; showScrollIcon = true" class="btn btn-add">Einkunftsart hinzufügen</button>
                </template>
                <template v-slot:menu v-if="showIncomeDropdownIsOpen">
                  <ul>
                    <li v-if="!showIncomeAgrarInput"
                        @click="showIncomeAgrarInput = true; showIncomeDropdownIsOpen = !showIncomeDropdownIsOpen">
                      Einkünfte aus Landwirtschaft
                    </li>
                    <li v-if="!showIncomeCommerceInput"
                        @click="showIncomeCommerceInput = true; showIncomeDropdownIsOpen = !showIncomeDropdownIsOpen">
                      Einkünfte aus Gewerbebetrieb
                    </li>
                    <li v-if="!showIncomeIndependentWorkInput"
                        @click="showIncomeIndependentWorkInput = true; showIncomeDropdownIsOpen = !showIncomeDropdownIsOpen">
                      Einkünfte aus selbstständiger Arbeit
                    </li>
                    <li v-if="!showIncomeCapitalInput"
                        @click="showIncomeCapitalInput = true; showIncomeDropdownIsOpen = !showIncomeDropdownIsOpen">
                      Einkünfte aus Kapitalvermögen
                    </li>
                    <li v-if="!showIncomeRentInput"
                        @click="showIncomeRentInput = true; showIncomeDropdownIsOpen = !showIncomeDropdownIsOpen">
                      Einkünfte aus Vermietung
                    </li>
                    <li v-if="!showIncomeOtherInput"
                        @click="showIncomeOtherInput = true; showIncomeDropdownIsOpen = !showIncomeDropdownIsOpen">
                      Sonstige Einkünfte
                    </li>
                  </ul>
                </template>
              </dropdown>
            </div>
          </div>
        </template>
        <template v-slot:tab3>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  Werbungskostenpauschale
                  <tooltip text="Aufwendungen zur Erwerbung, Sicherung und Erhaltung der Einnahmen können steuerlich
                  geltend gemacht werden. Dazu zählen z.B. Fahrtkosten, Kosten für Arbeitsmittel oder Fortbildung.
                  Jeder Arbeitnehmer hat einen jährlichen Arbeitnehmerpauschbetrag von 1.000 Euro zur Verfügung.
                  2.000 Euro für gemeinsam veranlagte Ehepaare, wenn der Partner berufstätig ist. Beträge über den
                  Freibetrag hinaus können nur durch detaillierte Angaben und Belege geltend gemacht werden."></tooltip>
                </span>
                <vf-input v-model.number="werbungskosten" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="userData.hasKids && userData.isSingleParent">
                <span class="form-group__headline">
                  Entlasungsbetrag für Alleinerziehende
                  <tooltip text="Der Entlastungsbetrag für Alleinerziehende senkt Deine Steuerbelastung.
                  Alleinerziehende erhalten 2021 für das erste Kind einen Entlastungsbetrag von 4.008 Euro.
                  Für jedes weitere Kind erhöht sich der Entlastungsbetrag um jeweils 240 Euro."></tooltip>
                   </span>
                <vf-input v-model.number="entlastungAlleinerziehend" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="userData.hasKids && showAusbildungsfreibetrag">
                <span class="form-group__headline">
                  Ausbildungsfreibetrag
                  <tooltip text="Der Ausbildungsfreibetrag ist für Eltern gedacht, die ihr Kind während einer
                  Berufsausbildung finanziell unterstützen. Dieser Steuerfreibetrag wird auf die Einkommensteuer
                  der Eltern angerechnet. Unter Berücksichtigung verschiedener Voraussetzungen können Sie – ohne
                  Ausbildungskosten nachweisen zu müssen – den Ausbildungsfreibetrag in Höhe von 924 Euro in der
                  „Anlage Kind“ geltend machen. Für jeden vollen Kalendermonat, in dem die Voraussetzungen für den
                  Freibetrag nicht erfüllt sind, vermindert sich dieser um ein Zwölftel."></tooltip>
                </span>
                <vf-input v-model.number="ausbildungsfreibetrag" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showEntfernungspauschale">
                <span class="form-group__headline">
                  Entfernungspauschale
                  <tooltip text="Fahrten zwischen Wohnung und Arbeitsstätte können über die sog. Entfernungspauschale
                  in Ihrer Einkommensteuererklärung geltend gemacht werden.
                  2021 beträgt die Entfernungspauschale 0,35 EUR pro Kilometer und gilt für Wege zwischen Wohnung und
                  erster Tätigkeitsstätte.

                  Bei der Berechnung der Strecke sind nur volle Entfernungskilometer anzusetzen. Ob Sie die Strecke mit
                  Auto, Fahrrad oder auch mit öffentlichen Verkehrsmitteln zurücklegen, spielt dabei keine Rolle."></tooltip>
                </span>
                <vf-input v-model.number="entfernungspauschale" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showUmzugskostenpauschale">
                <span class="form-group__headline">
                  Umzugskostenpauschale
                  <tooltip text="Wechseln Sie aus beruflichen Gründen den Wohnort, können Sie die Ausgaben für den
                  Umzug bei der Steuererklärung geltend machen. Singles können 860 Euro, Ehepaare 1.720 Euro ansetzen,
                  ohne die Einzelkosten belegen zu müssen. Übersteigen die Kosten die Pauschale, können diese mit
                  Beleg auch von der Steuer abgesetzt werden."></tooltip>
                </span>
                <vf-input v-model.number="umzugskostenpauschale" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showUebungsleiterfreibetrag">
                <span class="form-group__headline">
                  Übungsleiterfreibetrag
                  <tooltip text="Wer nebenberuflich als Ausbilder, Dozent, Erzieher oder Künstler tätig ist, kann den
                  Übungsleiterfreibetrag benutzen. Dieser stellt Aufwandsentschädigungen und Einnahmen von bis zu
                  3.300 Euro steuerfrei. Voraussetzung ist, dass man für eine gemeinnützige oder öffentlich-rechtliche
                  Körperschaft gearbeitet hat."></tooltip>
                </span>
                <vf-input v-model.number="uebungsleiterfreibetrag" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showHomeOfficePauschale">
                <span class="form-group__headline">
                  Home Office Pauschale
                  <tooltip text="Die Home Office Pauschale beträgt 5 Euro pro Tag, maximal
                  jedoch 600 Euro im Kalenderjahr. Das entspricht also 120 Tagen im Homeoffice. Damit sollen diejenigen
                  entlastet werden, die während der Corona-Pandemie von zuhause gearbeitet haben."></tooltip>
                </span>
                <vf-input v-model.number="homeOffice" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showEhrenamtsfreibetrag">
                <span class="form-group__headline">
                  Ehrenamtsfreibetrag
                  <tooltip text="Ehrenamtlich Tätige erhalten jährlich einen Freibetrag von 720 Euro. Dieser
                  Ehrenamtsfreibetrag kann nur über eine Steuererklärung genutzt werden."></tooltip>
                </span>
                <vf-input v-model.number="ehrenamtsfreibetrag" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showPflegepauschbetrag">
                <span class="form-group__headline">
                  Pflegepauschbetrag
                  <tooltip text="Wenn man Angehörige ohne Bezahlung häuslich pflegt, kann man den Pflegepauschbetrag von
                  1.800 Euro geltend machen. Allerdings müssen die Angehörigen hilflos sein oder Pflegegrad 4 oder 5 haben.
                  Falls mehrere Personen sich die Pflege teilen, muss der Pflegepauschbetrag aufgeteilt werden."></tooltip>
                </span>
                <vf-input v-model.number="pflegepauschbetrag" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showHinterbliebenenpauschbetrag">
                <span class="form-group__headline">
                  Hinterbliebenenpauschbetrag
                  <tooltip text="Witwen, Witwer und (Halb-)Waisen, die Hinterbliebenenbezüge erhalten, können einen
                  Pauschbetrag von 370 Euro im Jahr nutzen. Steht der Hinterbliebenenpauschbetrag dem eigenen Kind zu,
                  für das man Kindergeld oder den Kinderfreibetrag erhält, kann der Pauschbetrag auf Antrag auf das
                  Elternteil übertragen werden."></tooltip>
                </span>
                <vf-input v-model.number="hinterbliebene" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showAltersentlastungsbetrag">
                <span class="form-group__headline">
                  Altersentlastungsbetrag
                  <tooltip text="Rentner ab 64, die vor 1975 geboren sind, haben Anspruch auf den Altersentlastungsbetrag.
                  Wie hoch dieser Freibetrag ist, hängt vom Geburtsdatum ab. Das Finanzamt berechnet den Freibetrag
                  automatisch, wenn es die Einkommensteuer berechnet. Nähere Informationen finden sie auf Ihrem
                  Einkommenssteuerbescheid."></tooltip>
                </span>
                <vf-input v-model.number="altersentlastungsbetrag" type="number" suffix="€"></vf-input>
              </div>
              <div class="form-group" v-if="showSonstige">
                <span class="form-group__headline">
                  Sonstige Freibeträge
                  <tooltip text="Möchten Sie noch weitere Frei- bzw Pauschbeträge geltend machen, können sie diese zusammenrechnen
                  und hier eintragen. Weitere Frei-/Pauschbeträge sind z.B: Behindertenpauschbetrag, Versorgungsfreibetrag,
                  Unterhaltshöchstbetrag und Verpflegungspauschale."></tooltip>
                </span>
                <vf-input v-model.number="sonstiges" type="number" suffix="€"></vf-input>
              </div>

              <dropdown :is-open="showFreeAmountDropdownIsOpen" v-if="showFreeAmountDropdown">
                <template v-slot:target>
                  <button  @click="showFreeAmountDropdownIsOpen = !showFreeAmountDropdownIsOpen; showScrollIcon = true" class="btn btn-add">Freibetrag hinzufügen</button>
                </template>
                <template v-slot:menu v-if="showFreeAmountDropdownIsOpen">
                  <ul>
                    <li v-if="userData.hasKids && !showAusbildungsfreibetrag"
                        @click="addFreeAmount('ausbildungsfreibetrag')">
                      Ausbildungsfreibetrag
                    </li>
                    <li v-if="!showEntfernungspauschale"
                        @click="addFreeAmount('entfernungspauschale')">
                      Entfernungspauschale
                    </li>
                    <li v-if="!showUmzugskostenpauschale"
                        @click="addFreeAmount('umzugskostenpauschale')">
                      Umzugskostenpauschale
                    </li>
                    <li v-if="!showUebungsleiterfreibetrag"
                        @click="addFreeAmount('uebungsleiterfreibetrag')">
                      Übungsleiterpauschale
                    </li>
                    <li v-if="!showHomeOfficePauschale"
                        @click="addFreeAmount('homeOffice')">
                      Home Office Pauschale
                    </li>
                    <li v-if="!showEhrenamtsfreibetrag"
                        @click="addFreeAmount('ehrenamtsfreibetrag')">
                      Ehrenamtsfreibetrag
                    </li>
                    <li v-if="!showPflegepauschbetrag"
                        @click="addFreeAmount('pflegepauschbetrag')">
                      Pflegepauschbetrag
                    </li>
                    <li v-if="!showHinterbliebenenpauschbetrag"
                        @click="addFreeAmount('hinterbliebene')">
                      Hinterbliebenenpauschbetrag
                    </li>
                    <li v-if="!showAltersentlastungsbetrag"
                        @click="addFreeAmount('altersentlastungsbetrag')">
                      Altersenlastungsbetrag
                    </li>
                    <li v-if="!showSonstige"
                        @click="addFreeAmount('sonstiges')">
                      Sonstige Freibeträge
                    </li>
                  </ul>
                </template>
              </dropdown>
            </div>
          </div>
        </template>
        <template v-slot:tab4>
          <h3>Versorgungsaufwendungen <tooltip text="Versicherungsbeiträge zur Vorsorge können als Sonderausgaben abgesetzt werden.
                  Dazu gehören Kranken-, Pflege- und Rentenversicherung, sowie Beiträge zur Altersvorsorge.
                  Die Beiträge zur Pflege- und Rentenversicherung werden anhand der geltenden Steuersätze ermittelt."></tooltip></h3>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  Krankenversicherung
                </span>
                <toggle-switch
                  toggle-on-label="gesetzlich"
                  toggle-off-label="privat"
                  toggle-on-value="gesetzlich"
                  toggle-off-value="privat"
                  :selected=userData.expenses.healthInsurance
                  id="healthInsurance"
                  name="healthInsurance"
                  @input="e => userData.expenses.healthInsurance = e"></toggle-switch>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group" v-if="userData.expenses.healthInsurance === 'gesetzlich'">
                <span class="form-group__headline">
                  Zusatzbeitrag
                </span>
                <vf-input v-model.number="additionalHealthContribution" type="number" suffix="%"></vf-input>
              </div>
              <div class="form-group" v-if="userData.expenses.healthInsurance === 'privat'">
                <span class="form-group__headline">
                  Beitrag
                </span>
                <vf-input v-model.number="privatHealthContribution" type="number" suffix="€"></vf-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  Weitere Vorsorgeaufwendungen
                  <tooltip text="Weitere Vorsorgeaufwendungen können nur dann von der Steuer abgesetzt werden, wenn
                   die Aufwendungen für die Krankenversicherung noch nicht die 1.900€-Grenze bzw 3.800€ bei gemeinsam veranlagten Ehepaaren,
                   überschritten haben. Weitere Vorsorgeaufwendungen sind unter anderem Arbeitslosen-, Haftpflicht- und Unfallversicherungen."></tooltip>
                </span>
                <vf-input v-model.number="additionalPrecaution" type="number" suffix="€"></vf-input>
              </div>
            </div>
          </div>
          <h3>Sonstige Aufwendungen</h3>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <span class="form-group__headline">
                  Sonderausgaben
                  <tooltip text="Auch private Ausgaben dürfen Sie teils geltend machen. Als Sonderausgaben bzw.
                  außergewöhnliche Belastungen mindern sie die Steuerlast.

                  Zu den allgemeinen außergewöhnlichen Belastungen zählen Krankheitskosten, Aufwendungen für Hilfsmittel
                  wie Brillen und Zahnprothesen, Kosten für Bestattungen oder auch haushaltsnahe Dienstleistungen.

                  Möchten Sie, dass Sonderausgaben oder außergewöhnliche Belastungen in der Berechnung berücksichtigt werden,
                  dann rechnen Sie diese bitte zusammen und tragen Sie sie in das Feld ein."></tooltip>
                </span>
                <vf-input v-model.number="specialExpenses" type="number" suffix="€"></vf-input>
              </div>
            </div>
          </div>
        </template>
      </stepper>
      <!-- Ergebnisseite -->
      <anlagemglk v-if="soliBerechnet"></anlagemglk>

      <scroll-icon v-if="showScrollIcon"></scroll-icon>
    </div>
    <div class="wrapper__sidebar">
      <sidebar
        :est-ersparnis="userData.estErsparnis"
        :soli-ersparnis="userData.soliErsparnis"
        :soli-berechnet="soliBerechnet">
        <template v-slot:zwischenergebnis v-if="!soliBerechnet">
          <div class="zwischenergebnis">
            <span class="sidebar__headline">Ihre Angaben:</span>
            <ul class="sidebar__info">
              <li>
                Summe aller Einkünfte
                <span class="number">
                  {{ (sumOfIncome !== 0) ? sumOfIncome : '&minus;'| numberFormat}}
                </span>
              </li>
              <li>
                &minus; Freibeträge
                <span class="number">
                  {{ (sumOfFreeAmounts !== 0 && sumOfIncome !== 0) ? '&minus; ': ''}}
                  {{ (sumOfFreeAmounts !== 0 && sumOfIncome !== 0) ? sumOfFreeAmounts : '&minus;'| numberFormat }}</span>
              </li>
              <li>
                &minus; Aufwendungen
                <span class="number">
                  {{ (sumOfExpenses !== 0) ? '&minus; ': ''}}
                  {{ (sumOfExpenses !== 0) ? sumOfExpenses : '&minus;'| numberFormat }}</span>
              </li>
              <li>
              <span class="result"
                    v-if="(userData.relationShipStatus === 'verheiratet' && userData.cashSplitting)">
                Gemeinsames <br> zu versteuerndes Einkommen
              </span>
                <span v-else>zu versteuerndes Einkommen</span>
                <span class="number">
                  {{ (sumOfIncome !== 0) ? sumOfIncome-sumOfFreeAmounts-sumOfExpenses : '&minus;'| numberFormat}}</span>
              </li>
            </ul>
          </div>
        </template>
        <template v-slot:ergebnis v-if="soliBerechnet">
          <div class="ergebnis">
            <span class="sidebar__headline">Ihr Ergebnis:</span>
            <ul class="sidebar__info">
              <li>
                <span v-if="(userData.relationShipStatus === 'verheiratet' && userData.cashSplitting)">Gemeinsames Einkommen</span>
                <span v-else>zu versteuerndes Einkommen</span>
                <span class="number">
               {{ (userData.zve21 >= 0) ? userData.zve21 : 0 | numberFormat}}</span>
              </li>
              <li>
                Einkommenssteuer
                <span class="number">{{ userData.est21 | numberFormat}}</span>
              </li>
              <li>
                Solidaritätsbeitrag
                <span class="number">{{ userData.soli21 | numberFormat}}</span>
              </li>
              <li v-if="userData.churchTax">
                Kirchensteuer
                <span class="number">{{ userData.churchTaxAmount21 | numberFormat}}</span>
              </li>
              <li class="soli">
                Soli-Ersparnis
                <span class="number">{{ userData.soliErsparnis | numberFormat}}
                <span class="info">/Jahr </span>
                <span class="info-2"> *</span>
              </span>
              </li>
            </ul>
          </div>

        </template>
      </sidebar>
    </div>
  </div>
</template>

<script>
import Sidebar from "./components/layout/Sidebar";
import Stepper from "./components/form/Stepper/Stepper";
import ToggleSwitch from "./components/form/Input/ToggleSwitch";
import VfInputSelect from "./components/form/Input/VfInputSelect";
import VfInput from "./components/form/Input/VfInput";
import Dropdown from "./components/Dropdown";
import Anlagemglk from "./components/layout/Anlagemglk";
import ScrollIcon from "./components/ScrollIcon";
import Tooltip from "./components/Tooltip";

export default {
  name: 'App',
  components: {
    Sidebar,
    Stepper,
    ToggleSwitch,
    VfInputSelect,
    VfInput,
    Dropdown,
    Anlagemglk,
    ScrollIcon,
    Tooltip
  },
  created: function () {
    // `this` points to the vm instance
    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

  },
  mounted() {
    const scrollIcon = document.getElementById('wrapper');

    this.showScrollIcon = scrollIcon.clientHeight !== scrollIcon.scrollHeight;
    scrollIcon.addEventListener('scroll', (e) => {
      this.showScrollIcon = (e.target.scrollHeight - e.target.clientHeight) !== e.target.scrollTop;
    });
  },
  data() {
    return {
      printResults: false,
      soliBerechnet: false,
      showScrollIcon: true,
      stepItems: [
        {label: 'Persönliches', id: 1},
        {label: 'Einkommen', id: 2},
        {label: 'Freibeträge', id: 3},
        {label: 'Aufwendungen', id:4}
      ],
      activeTab: 1,
      userData: {
        relationShipStatus: 'ledig',  //Beziehungsstatus
        cashSplitting: false,         //Ehegattensplitting
        hasKids: false,               //Hat Kinder
        isSingleParent: false,        //Alleinerziehend
        kidsFreeAmount: 0.5,          //Kinderfreibetrag
        sumOfKids: 0,                 //Anzahl der Kinder
        state: 'nrw',                 //Bundesland
        churchTax: true,              //Kirchensteuer
        income: {                     //List of useres incomes
          brutto: 0,                  //Einkünfte aus nicht-selbstständiger Arbeit
          agrar: 0,                   //EInkünfte aus Land-&Forstwirtschaft
          commerce: 0,                //Einkünfte aus Gewerbebetrieb
          independentWork: 0,         //Einkünfte aus selbstständiger Arbeit
          capital: 0,                 //EInkünfte aus Kapialvermögen
          rent: 0,                    //Einkünfte aus Vermietung/Verpachtung
          other: 0,                   //Sonstige Einkünfte
          benefits: 0,                //Entgeltersatzleistungen
        },
        freeAmounts2021: {                //List of users free amounts
          werbungskosten: 1000,
          entlastungAlleinerziehend: 0,
          entfernungspauschale: 0,
          umzugskostenpauschale: 0,
          uebungsleiterfreibetrag: 0,
          ehrenamtsfreibetrag: 0,
          pflegepauschbetrag: 0,
          hinterbliebene: 0,
          altersentlastungsbetrag: 0,
          homeOffice: 0,
          ausbildungsfreibetrag: 0,
          sonstiges: 0
        },
        freeAmounts2020: {                //List of users free amounts
          werbungskosten: 1000,
          entlastungAlleinerziehend: 0,
          entfernungspauschale: 0,
          umzugskostenpauschale: 0,
          uebungsleiterfreibetrag: 0,
          ehrenamtsfreibetrag: 0,
          pflegepauschbetrag: 0,
          hinterbliebene: 0,
          altersentlastungsbetrag: 0,
          ausbildungsfreibetrag: 0,
          sonstiges: 0

        },
        expenses: {
          healthInsurance: 'gesetzlich',
          healthContribution: 14.6,
          additionalHealthContribution: 1.3,  //Zusatzbeitrag gesetzliche KV
          privatHealthContribution: 0,        //Beitrag private KV
          additionalPrecaution: 0,            //Weitere Vorsorgeaufwendungen
          specialExpenses: 0,                 //Sonderausgaben
          rvContribution: 18.6,
          pvContribution: [3.05, 3.30],       //3,05 Prozent bzw. für über 23 jährige Kinderlose 3,30 %
        },
        est21: 0,
        est20: 0,
        churchTaxAmount21: 0,
        churchTaxAmount20: 0,
        soli21: 0,
        soli20: 0,
        soliErsparnis: 0,
        estErsparnis: 0,
      },
      showIncomeDropdownIsOpen: false,
      showFreeAmountDropdownIsOpen: false,
      showIncomeAgrarInput: false,
      showIncomeCommerceInput: false,
      showIncomeIndependentWorkInput: false,
      showIncomeCapitalInput: false,
      showIncomeRentInput: false,
      showIncomeOtherInput: false,
      showAusbildungsfreibetrag: false,
      showEntfernungspauschale: false,
      showUmzugskostenpauschale: false,
      showUebungsleiterfreibetrag: false,
      showHomeOfficePauschale: false,
      showEhrenamtsfreibetrag: false,
      showPflegepauschbetrag: false,
      showHinterbliebenenpauschbetrag: false,
      showAltersentlastungsbetrag: false,
      showSonstige: false,
      freeAmounts2021: {
        werbungskosten: 1000,
        uebungsleiterfreibetrag: 3000,        //Übungsleiterfreibetrag
        ehrenamtsfreibetrag: 840,             //Ehrenamtsfreibetrag
        pflegepauschbetrag: 1800,             //Pflegepauschbetrag
        hinterbliebene: 370,                  //Hinterbliebenenpauschbetrag
        entfernungspauschale: 0,              //Entfernungspauschale - muss individuell ermittelt werden
        altersentlastungsbetrag: 0,           //Alterentlastungsbetrag - muss individuell ermittelt werden
        homeOffice: 600,                      //Home Office Pauschale
        kinderfreibetrag: 8388,
        entlastungAlleinerziehend: 4008,      //+ 240 je weiteres kind
        ausbildungsfreibetrag: 924,
        sonstiges: 0,
        umzugskostenpauschale: 860,           //+ 573 je weiteres kind
        sonderausgabenpauschale: 36,          //72 ehepaar
        kvBbg: 58050,                         //KV / PV Beitragsbemessungsgrenze
        rvWestBbg: 85200                      //RV West Beitragsbemessungsgrenze
      },
      freeAmounts2020: {
        werbungskosten: 1000,
        uebungsleiterfreibetrag: 2400,        //Übungsleiterfreibetrag
        ehrenamtsfreibetrag: 720,             //Ehrenamtsfreibetrag
        pflegepauschbetrag: 924,              //Pflegepauschbetrag
        hinterbliebene: 370,                  //Hinterbliebenenpauschbetrag
        entfernungspauschale: 0,              //Entfernungspauschale - muss individuell ermittelt werden
        altersentlastungsbetrag: 0,           //Alterentlastungsbetrag - muss individuell ermittelt werden
        kinderfreibetrag: 7812,
        entlastungAlleinerziehend: 4008,
        ausbildungsfreibetrag: 924,
        umzugskostenpauschale: 820,           //+ 361 je weiteres kind
        sonderausgabenpauschale: 36,          //72 ehepaar
        kvBbg: 56250,                         //KV / PV Beitragsbemessungsgrenze
        rvWestBbg: 82800                      //RV West Beitragsbemessungsgrenze
      }
    }
  },
  methods: {
    setRelationShipStatus(e) {
      this.userData.relationShipStatus = e;
      if (e === 'ledig') {
        this.userData.cashSplitting = false;
      }
      if (e === 'verheiratet') {
        this.userData.isSingleParent = false;
        this.userData.cashSplitting = true;
        this.userData.freeAmounts2021.entlastungAlleinerziehend = 0;
        this.userData.freeAmounts2020.entlastungAlleinerziehend = 0;
      }

      this.userData.freeAmounts2021.werbungskosten = this.werbungskosten;
      this.userData.freeAmounts2020.werbungskosten = this.werbungskosten;
    },
    setCashSplitting(e) {
      this.userData.cashSplitting = JSON.parse(e);

      //Passe Freibeträge an die von gemeinsamer veranlagung beeinflusst sind
      this.userData.freeAmounts2021.werbungskosten = this.werbungskosten;
      this.userData.freeAmounts2020.werbungskosten = this.werbungskosten;

    },
    setKids(e) {
      this.userData.hasKids = JSON.parse(e);
      if (!JSON.parse(e)) {
        this.userData.sumOfKids = 0;
        this.userData.kidsFreeAmount = 0;
        this.userData.isSingleParent = false;
        this.userData.freeAmounts2021.entlastungAlleinerziehend = 0;
        this.userData.freeAmounts2020.entlastungAlleinerziehend = 0;
      } else {
        this.userData.sumOfKids = 1;
        this.userData.kidsFreeAmount = 0.5;
      }
    },
    setKidsFreeAmount(e) {
      this.userData.kidsFreeAmount = JSON.parse(e);
      this.userData.freeAmounts2021.entlastungAlleinerziehend = this.entlastungAlleinerziehend;
      this.userData.freeAmounts2020.entlastungAlleinerziehend = this.entlastungAlleinerziehend;
    },
    setSumOfKids(e) {
      this.userData.sumOfKids = JSON.parse(e);
      this.userData.kidsFreeAmount = this.userData.sumOfKids / 2;
      this.userData.freeAmounts2021.entlastungAlleinerziehend = this.entlastungAlleinerziehend;
      this.userData.freeAmounts2020.entlastungAlleinerziehend = this.entlastungAlleinerziehend;
    },
    setSingleParent(e) {
      this.userData.isSingleParent = JSON.parse(e);
      this.userData.freeAmounts2021.entlastungAlleinerziehend = this.entlastungAlleinerziehend;
      this.userData.freeAmounts2020.entlastungAlleinerziehend = this.entlastungAlleinerziehend;
    },
    changeActiveTab(action) {
      switch (action) {
        case 'next':
          if (this.activeTab !== this.stepItems.length) {
            this.activeTab += 1;
          }
          break;
        case 'back':
          if (this.activeTab >= 1) {
            this.activeTab -= 1;
          }
          break;
      }
      // this.showScrollIcon = true;
    },
    toggleFreeAmountDropdown() {
      this.showFreeAmountDropdownIsOpen = !this.showFreeAmountDropdownIsOpen;
    },
    addFreeAmount(freeAmount) {
      this.toggleFreeAmountDropdown();
      switch (freeAmount) {
        case 'ausbildungsfreibetrag':
          this.showAusbildungsfreibetrag = true;
          this.userData.freeAmounts2021.ausbildungsfreibetrag = this.calcAusbildungsfreibetrag(this.freeAmounts2021.ausbildungsfreibetrag);
          this.userData.freeAmounts2020.ausbildungsfreibetrag = this.calcAusbildungsfreibetrag(this.freeAmounts2020.ausbildungsfreibetrag);
          break;
        case 'entfernungspauschale':
          this.showEntfernungspauschale = true;
          this.userData.freeAmounts2021.entfernungspauschale = this.freeAmounts2021.entfernungspauschale;
          this.userData.freeAmounts2020.entfernungspauschale = this.freeAmounts2020.entfernungspauschale;
          break;
        case 'umzugskostenpauschale':
          this.showUmzugskostenpauschale = true;
          this.userData.freeAmounts2021.umzugskostenpauschale = this.calcUmzugskostenpauschale(this.freeAmounts2021.umzugskostenpauschale);
          this.userData.freeAmounts2020.umzugskostenpauschale = this.calcUmzugskostenpauschale(this.freeAmounts2020.umzugskostenpauschale);
          break;
        case 'uebungsleiterfreibetrag':
          this.showUebungsleiterfreibetrag = true;
          this.userData.freeAmounts2021.uebungsleiterfreibetrag = this.freeAmounts2021.uebungsleiterfreibetrag;
          this.userData.freeAmounts2020.uebungsleiterfreibetrag = this.freeAmounts2020.uebungsleiterfreibetrag;
          break;
        case 'homeOffice':
          this.showHomeOfficePauschale = true;
          this.userData.freeAmounts2021.homeOffice = this.freeAmounts2021.homeOffice;
          break;
        case 'ehrenamtsfreibetrag':
          this.showEhrenamtsfreibetrag = true;
          this.userData.freeAmounts2021.ehrenamtsfreibetrag = this.freeAmounts2021.ehrenamtsfreibetrag;
          this.userData.freeAmounts2020.ehrenamtsfreibetrag = this.freeAmounts2020.ehrenamtsfreibetrag;
          break;
        case 'pflegepauschbetrag':
          this.showPflegepauschbetrag = true;
          this.userData.freeAmounts2021.pflegepauschbetrag = this.freeAmounts2021.pflegepauschbetrag;
          this.userData.freeAmounts2020.pflegepauschbetrag = this.freeAmounts2020.pflegepauschbetrag;
          break;
        case 'hinterbliebene':
          this.showHinterbliebenenpauschbetrag = true;
          this.userData.freeAmounts2021.hinterbliebene = this.freeAmounts2021.hinterbliebene;
          this.userData.freeAmounts2020.hinterbliebene = this.freeAmounts2020.hinterbliebene;
          break;
        case 'altersentlastungsbetrag':
          this.showAltersentlastungsbetrag = true;
          this.userData.freeAmounts2021.altersentlastungsbetrag = this.freeAmounts2021.altersentlastungsbetrag;
          this.userData.freeAmounts2020.altersentlastungsbetrag = this.freeAmounts2020.altersentlastungsbetrag;
          break;
        case 'sonstiges':
          this.showSonstige = true
          this.userData.freeAmounts2021.sonstiges = this.freeAmounts2021.sonstiges;
          break;
      }
    },
    calcUmzugskostenpauschale(u) {
      if (this.checkCashSplitting()) {
        return u * 2
      } else {
        return u
      }
    },
    calcAusbildungsfreibetrag(p) {
      if (this.userData.hasKids) {
        if (this.checkCashSplitting()) {
          //verheiratet + zusammen veranlagt
          return p
        } else {
          return p / 2
        }
      } else {
        return 0
      }
    },
    checkCashSplitting() {
      return this.userData.relationShipStatus === 'verheiratet' && this.userData.cashSplitting;
    },
    showUserData(sumFa2020, sumFa2021, sumA20, sumA21, zve20, zve21, estOhneKf20, estOhneKf21, kinderfreibetrag2020, kinderfreibetrag2021, estMitKf20, estMitKf21, kindergeld2020, kindergeld2021) {
      console.log('############### BERECHNUNG GESTARTET ##################');
      console.log('################## PERSÖNLICHES #######################');
      console.log('Beziehung', this.userData.relationShipStatus);
      console.log('Gemeinsame Veranlagung', this.userData.cashSplitting);
      console.log('Hat Kinder', this.userData.hasKids);
      console.log('Anzahl der Kinder', this.userData.sumOfKids);
      console.log('Kinderfreibetrag', this.userData.kidsFreeAmount);
      console.log('Ist Alleinerziehend', this.userData.isSingleParent);
      console.log('Bezahlt Kirchensteuer', this.userData.churchTax);
      console.log('Bundesland', this.userData.state);

      console.log('#################### EINKÜNFTE ########################');
      console.log('Summe aller Einkünfte', this.sumOfIncome);

      console.log('#################### FREIBETRÄGE ######################');
      console.log('Summe Freibeträge 2020', sumFa2020);
      console.log('Summe Freibeträge 2021', sumFa2021);

      console.log('#################### AUFWENDUNGEN ######################');
      console.log('Summe Aufwendungen 2020', sumA20);
      console.log('Summe Aufwendungen 2021', sumA21);

      console.log('################ EINKOMMENSSTEUER (EST) ################');
      if (this.userData.hasKids) {
        console.log('###### ZVE 2020 (ohne Kinderfreibetrag)', zve20);
        console.log('###### ZVE 2021 (ohne Kinderfreibetrag)', zve21);
        console.log('EST ohne Kinderfreibetrag 2020', estOhneKf20);
        console.log('EST ohne Kinderfreibetrag 2021', estOhneKf21);
        console.log('------')
        console.log('Anzahl der Kinder:', this.userData.sumOfKids);
        console.log('------')
        if (this.checkCashSplitting()) {
          console.log('Kinderfreibetrag 2020 bei gemeinsamer Veranlagung', kinderfreibetrag2020);
          console.log('Kinderfreibetrag 2021 bei gemeinsamer Veranlagung', kinderfreibetrag2021);
        } else {
          console.log('Kinderfreibetrag 2020', kinderfreibetrag2020);
          console.log('Kinderfreibetrag 2021', kinderfreibetrag2021);
        }

        console.log('EST mit Kinderfreibetrag 2020', estMitKf20);
        console.log('EST mit Kinderfreibetrag 2021', estMitKf21);
        console.log('------')
        console.log('Kindergeld 2020', kindergeld2020);
        console.log('Kindergeld 2021', kindergeld2021);

        let diff20 = estOhneKf20 - estMitKf20;
        let diff21 = estOhneKf21 - estMitKf21;

        if (diff20 > kindergeld2020) {
          console.log('kinderfreibetrag lohnt 2020 sich mehr');
        } else {
          console.log('kindergeld lohnt sich 2020 mehr');
        }

        console.log('Einkommenssteuer 2020', this.userData.est20);

        if (diff21 > kindergeld2021) {
          console.log('kinderfreibetrag lohnt 2021 sich mehr')
        } else {
          console.log('kindergeld lohnt sich 2021 mehr')
        }

        console.log('Einkommenssteuer 2021', this.userData.est21);

      } else {
        console.log('ZVE 2020', zve20);
        console.log('ZVE 2021', zve21);
        console.log('Einkommenssteuer 2020', this.userData.est20);
        console.log('Einkommenssteuer 2021', this.userData.est21);
      }

      console.log('Steuerersparnis', this.userData.estErsparnis);

      console.log('######################### SOLI #########################');
      console.log('Soli 2020', this.userData.soli20);
      console.log('Soli 2021', this.userData.soli21);
      console.log('Soli Ersparnis', this.userData.soliErsparnis);
    },
    calcSumOfFreeAmounts(freeAmounts, print) {
      if (print) console.log('######### LISTE DER FREIBETRÄGE FÜR AKTUELLES JAHR #########');
      let sum = 0;
      Object.keys(freeAmounts).forEach(function (key) {
        if (print) console.log(key, freeAmounts[key])
        sum = sum + freeAmounts[key];
      });
      return sum;
    },
    calcKV(bbg, brutto) { // bbg - beitragsbemessungsgrenze
      const expenses = this.userData.expenses;

      if (expenses.healthInsurance === 'gesetzlich') {
        const kvSatz = expenses.healthContribution + expenses.additionalHealthContribution;
        let beitragspflichtigesEinkommen;

        if (brutto > bbg) {
          beitragspflichtigesEinkommen = bbg;
        } else {
          beitragspflichtigesEinkommen = brutto;
        }
        return parseInt(((beitragspflichtigesEinkommen * kvSatz) / 100) / 2);
      } else if (expenses.healthInsurance === 'privat') {
        return parseInt(expenses.privatHealthContribution);
      }
    },
    calcRV(bbg, brutto) {
      const rvSatz = this.userData.expenses.rvContribution;
      let beitragspflichtigesEinkommen;

      if (brutto > bbg) {
        beitragspflichtigesEinkommen = bbg;
      } else {
        beitragspflichtigesEinkommen = brutto;
      }

      return parseInt(((beitragspflichtigesEinkommen * rvSatz) / 100) / 2);
    },
    calcPV(bbg, brutto) {
      const pvSatz = this.userData.expenses.pvContribution;
      let pv;
      if (!this.userData.hasKids) {
        pv = pvSatz[1]
      } else {
        pv = pvSatz[0]
      }
      let beitragspflichtigesEinkommen;
      if (brutto > bbg) {
        beitragspflichtigesEinkommen = bbg;
      } else {
        beitragspflichtigesEinkommen = brutto;
      }
      return parseInt(((beitragspflichtigesEinkommen * pv) / 100) / 2);
    },
    calcSumOfExpanses(bbgs, print) {
      let brutto = this.userData.income.brutto
      let kvBeitrag;
      let rvBeitrag;
      let pvBeitrag;
      let sum;

      if (this.checkCashSplitting()) {
        kvBeitrag = this.calcKV(bbgs.kvBbg, brutto / 2) * 2;
        rvBeitrag = this.calcRV(bbgs.rvWestBbg, brutto / 2) * 2;
        pvBeitrag = this.calcPV(bbgs.kvBbg, brutto / 2) * 2;
      } else {
        kvBeitrag = this.calcKV(bbgs.kvBbg, brutto);
        rvBeitrag = this.calcRV(bbgs.rvWestBbg, brutto);
        pvBeitrag = this.calcPV(bbgs.kvBbg, brutto);
      }

      if (print) {
        console.log('######### LISTE DER AUFWENDUNGEN FÜR AKTUELLES JAHR #########');
        console.log('KV Beitrag', kvBeitrag);
        console.log('PV Beitrag', pvBeitrag);
        console.log('RV Beitrag', rvBeitrag);
        console.log('Weitere Vorsorgeaufwendungen', this.userData.expenses.additionalPrecaution);
        console.log('Sonstige Aufwendungen', this.userData.expenses.specialExpenses);
      }

      sum = kvBeitrag + rvBeitrag + pvBeitrag;

      // Prüfe ob Vorsorgeaufwendungen mehr als 1900€ bzw 3800 sind
      // -> wenn weniger können noch andere Versicherungen abgesetz werden
      if (this.checkCashSplitting() && sum < 3800) {
        sum = sum + this.userData.expenses.additionalPrecaution
      } else if (!this.checkCashSplitting() && sum < 1900) {
        sum = sum + this.userData.expenses.additionalPrecaution
      }

      // Füge Sonderausgaben hinzu
      sum = sum + this.userData.expenses.specialExpenses

      return sum;

    },
    getNumberOfKids() {
      // //Berechne Anzahl der Kinder
      // //Annahme: Jedes Elternteil kommt halben Kinderfreibetrag pro Kind
      // return this.userData.kidsFreeAmount * 2;
      return this.userData.sumOfKids
    },
    calcKinderfreibetrag(year, kidsFreeAmount) {
      let kf
      if (this.userData.hasKids) {
        if (year === 2021) {
          kf = this.freeAmounts2021.kinderfreibetrag;
        } else if (year === 2020) {
          kf = this.freeAmounts2020.kinderfreibetrag;
        } else {
          console.error('Kinderfreibetrag kann nur für die Jahre 2021 und 2020 berechnet werden.')
        }

        return kf * kidsFreeAmount;
      } else {
        return 0;
      }
    },
    calcKindergeld(year, numberOfKids) {

      if (this.userData.hasKids) {
        // Setze Beträge pro Anzahl der Kinder für entsprechendes Jahr
        let kindergeld12;
        let kindergeld3;
        let kindergeld4;

        if (year === 2021) {
          kindergeld12 = 219;
          kindergeld3 = 225;
          kindergeld4 = 250;
        } else if (year === 2020) {
          kindergeld12 = 204;
          kindergeld3 = 210;
          kindergeld4 = 235;
        } else {
          console.error('Kindergeld kann nur für die Jahre 2021 und 2020 berechnet werden.')
        }

        // Berechne Kindergeld abhängig von der Anzahl der Kinder
        let kindergeld = 0;

        for (let i = 0; i <= numberOfKids; i++) {
          if (i === 1 || i === 2) {
            kindergeld = kindergeld + kindergeld12
          } else if (i === 3) {
            kindergeld = kindergeld + kindergeld3
          } else if (i >= 4) {
            kindergeld = kindergeld + kindergeld4
          }
        }
        return kindergeld * 12;
      } else {
        return 0;
      }
    },
    calcZve(year, freeAmounts, expenses) {
      // ZVE ohne Kinderfreibetrag
      let zve;
      if (this.sumOfIncome !== 0) {
        zve = this.sumOfIncome - freeAmounts - expenses;
      } else {
        zve = 0;
      }

      return zve
    },
    calcEst(year, zve) {
      if (year === 2021) {
        // console.log('2021');
        if (zve <= 9744) { //bis 9744€
          // console.log('bis 9744€')
          return 0

        } else if (zve > 9744 && zve <= 14753) { //9745€ bis 14753€
          // console.log('9745€ bis 14753€')
          let y = (zve - 9744) / 10000
          return parseInt((995.21 * y + 1400) * y);

        } else if (zve > 14753 && zve <= 57918) { //14754€ bis 57918€
          // console.log('14754€ bis 57918€')
          let z = (zve - 14753) / 10000
          return parseInt((208.85 * z + 2397) * z + 950.96);

        } else if (zve > 57918 && zve <= 274612) { //57919€ bis 274612€
          // console.log('57919€ bis 274612€')
          return parseInt(0.42 * zve - 9136.63);

        } else { //ab 274613€
          // console.log('ab 274613€')
          return parseInt(0.45 * zve - 17374.99);

        }
      } else if (year === 2020) {
        // console.log('2020');
        if (zve <= 9408) { //bis 9408€
          // console.log('ab 9408€')
          return 0

        } else if (zve > 9408 && zve <= 14532) { //9409€ bis 14532€
          // console.log('9409€ bis 14532€')
          let y = (zve - 9408) / 10000
          return parseInt((972.87 * y + 1400) * y);

        } else if (zve > 14532 && zve <= 57051) { //14533 bis 57051€
          // console.log('14533 bis 57051€')
          let z = (zve - 14532) / 10000
          return parseInt((212.02 * z + 2397) * z + 972.79);

        } else if (zve > 57051 && zve <= 270500) { //57052 bis 270500€
          // console.log('57052 bis 270500€')
          return parseInt(0.42 * zve - 8963.74);

        } else { //ab 270501€
          // console.log('ab 270501€')
          return parseInt(0.45 * zve - 17078.74);
        }
      } else {
        console.error('Einkommenssteuer kann nur für die Jahre 2021 und 2020 berechnet werden.')
      }
    },
    calcSoli(year, est) {
      let freigrenze1;
      let freigrenze2;
      if (year === 2021) {
        if (this.checkCashSplitting()) {
          freigrenze1 = 33912;
          freigrenze2 = 63055.13;
        } else {
          freigrenze1 = 16956;
          freigrenze2 = 31527.56;
        }

        if (est < freigrenze1) {
          return 0
        } else if (est >= freigrenze1 && est > freigrenze2) {
          return ((est * 5.5) / 100).toFixed(2);
        } else {
          return ((est - freigrenze1) * 11.9 / 100).toFixed(2);
        }

      } else if (year === 2020) {
        if (this.checkCashSplitting()) {
          freigrenze1 = 1994;
          freigrenze2 = 2681.38;
        } else {
          freigrenze1 = 972;
          freigrenze2 = 1340.69;
        }

        if (est < freigrenze1) {
          return 0
        } else if (est > freigrenze2) {
          return ((est * 5.5) / 100).toFixed(2);
        } else {
          return ((est - freigrenze1) * 20 / 100).toFixed(2);
        }
      } else {
        console.error('Der SOli kann nur für die Jahre 2021 und 2020 berechnet werden.')
      }
    },
    calcSoliErsparnis() {
      this.soliBerechnet = true;

      // 1 Ermittlung zve
      // 1.1 Summe aller Einkünfte
      // this.sumOfIncome

      // 1.2 Summe aller Freibeträge
      let sumFa2021 = this.calcSumOfFreeAmounts(this.userData.freeAmounts2021, this.printResults);
      let sumFa2020 = this.calcSumOfFreeAmounts(this.userData.freeAmounts2020, this.printResults);

      // 1.3 Summe aller Aufwendungen
      let sumA21 = this.calcSumOfExpanses(this.freeAmounts2021, this.printResults);
      let sumA20 = this.calcSumOfExpanses(this.freeAmounts2020, this.printResults);

      // 1.4 Zu versteuerndes Einkommen - Ohne Kinderfreibetrag
      let zve21 = this.calcZve(2021, sumFa2021, sumA21);
      let zve20 = this.calcZve(2020, sumFa2020, sumA20);

      this.userData.zve21 = zve21;
      this.userData.zve20 = zve20;

      // 2. Ermittlung der Einkommensteuer (est)
      let est21;
      let est20;

      let estOhneKf21;
      let estOhneKf20;
      if (this.checkCashSplitting()) {
        let halbiertesGemeinsamesZve21 = zve21 / 2;
        let halbiertesGemeinsamesZve20 = zve20 / 2;

        estOhneKf21 = this.calcEst(2021, halbiertesGemeinsamesZve21) * 2;
        estOhneKf20 = this.calcEst(2020, halbiertesGemeinsamesZve20) * 2;
      } else {
        estOhneKf21 = this.calcEst(2021, zve21);
        estOhneKf20 = this.calcEst(2020, zve20);
      }

      ////////////////////////////////////////////////////////////////////
      let kinderfreibetrag2020;
      let kinderfreibetrag2021;
      let kindergeld2020;
      let kindergeld2021;

      let estMitKf20;
      let estMitKf21;
      let zveMitKf20;
      let zveMitKf21;
      ////////////////////////////////////////////////////////////////////

      // Ermittle ob Kinderfreibtrag oder Kindergeld günstiger
      if (this.userData.hasKids) {

        //Rechnung mit Kinderfreibetrag
        kinderfreibetrag2020 = this.calcKinderfreibetrag(2020, this.userData.kidsFreeAmount);
        kinderfreibetrag2021 = this.calcKinderfreibetrag(2021, this.userData.kidsFreeAmount);
        // let kinderfreibetrag2020 = this.calcKinderfreibetrag(2020, this.userData.kidsFreeAmount);
        // let kinderfreibetrag2021 = this.calcKinderfreibetrag(2021, this.userData.kidsFreeAmount);
        //
        // let estMitKf20;
        // let estMitKf21;
        // let zveMitKf20;
        // let zveMitKf21;

        if (this.checkCashSplitting()) {
          // Pro Elternteil gibt es den halben Kinderfreibetrag
          // Zusammenveranlagte Paare können beide Anteile anrechnen
          kinderfreibetrag2020 = kinderfreibetrag2020 * 2;
          kinderfreibetrag2021 = kinderfreibetrag2021 * 2;

          zveMitKf20 = zve20 - kinderfreibetrag2020;
          zveMitKf21 = zve21 - kinderfreibetrag2021;

          estMitKf20 = this.calcEst(2020, zveMitKf20 / 2) * 2;
          estMitKf21 = this.calcEst(2021, zveMitKf21 / 2) * 2;
        } else {
          // Bei nicht zusammenveranlagten Paaren gilt die Rechnung nur für den Elternteil, der den Soli bedient
          zveMitKf20 = zve20 - kinderfreibetrag2020;
          zveMitKf21 = zve21 - kinderfreibetrag2021;

          estMitKf20 = this.calcEst(2020, zveMitKf20);
          estMitKf21 = this.calcEst(2021, zveMitKf21);
        }

        // Ermittle Anzahl der Kinder
        // let numberOfKids = this.getNumberOfKids();

        // Berechne Kindergeld
        // let kindergeld2020 = this.calcKindergeld(2020, this.userData.sumOfKids);
        // let kindergeld2021 = this.calcKindergeld(2021, this.userData.sumOfKids);
        kindergeld2020 = this.calcKindergeld(2020, this.userData.sumOfKids);
        kindergeld2021 = this.calcKindergeld(2021, this.userData.sumOfKids);

        // Günstigerprüfung
        let diff20 = estOhneKf20 - estMitKf20;
        let diff21 = estOhneKf21 - estMitKf21;

        // Prüfe was sich mehr lohnt
        if (diff20 > kindergeld2020) {
          // Weil Kinderfreibetrag günstiger ist die Eltern aber das ganze Jahr Kindergeld erhalten haben wird das Kindergeld zur Steuerlast addiert
          est20 = estMitKf20 + kindergeld2020;
        } else {
          est20 = estOhneKf20;
        }

        if (diff21 > kindergeld2021) {
          // Weil Kinderfreibetrag günstiger ist die Eltern aber das ganze Jahr Kindergeld erhalten haben wird das Kindergeld zur Steuerlast addiert
          est21 = estMitKf21 + kindergeld2021;
        } else {
          est21 = estOhneKf21;
        }
      } else {
        est21 = estOhneKf21;
        est20 = estOhneKf20;
      }

      this.userData.est21 = est21;
      this.userData.est20 = est20;
      this.userData.estErsparnis = est20 - est21;

      // 3. Soli ersparnis ermitteln
      let soli21 = this.calcSoli(2021, est21);
      let soli20 = this.calcSoli(2020, est20);

      this.userData.soli21 = soli21;
      this.userData.soli20 = soli20;

      let soliErsparnis = soli20 - soli21;
      soliErsparnis = parseFloat(soliErsparnis.toFixed(2));

      this.userData.soliErsparnis = soliErsparnis;

      // 4. Kirchensteuer berechnen
      let churchTax21 = this.calcChurchTax(est21);
      let churchTax20 = this.calcChurchTax(est20);

      this.userData.churchTaxAmount21 = churchTax21;
      this.userData.churchTaxAmount20 = churchTax20;

      if (this.printResults) this.showUserData(sumFa2020, sumFa2021, sumA20, sumA21, zve20, zve21, estOhneKf20, estOhneKf21, kinderfreibetrag2020, kinderfreibetrag2021, estMitKf20, estMitKf21, kindergeld2020, kindergeld2021);
    },
    calcChurchTax(est) {
      if (!this.userData.churchTax) {
        return 0;
      } else {
        let ct;
        if (this.userData.state === 'by' || this.userData.state === 'bw') ct = 8; else ct = 9

        return (est * ct) / 100;
      }
    },
  },
  computed: {
    //Format inputs from type number to make sure the type is number and not string
    //Necessary to get 0 when input is empty otherwise it will be an empty string.
    //This leads to errors in calculation step
    formattedBrutto: {
      get() {
        return this.userData.income.brutto
      },
      set(value) {
        this.userData.income.brutto = parseFloat(value) || 0
      }
    },
    formattedAgrar: {
      get() {
        return this.userData.income.agrar
      },
      set(value) {
        this.userData.income.agrar = parseFloat(value) || 0
      }
    },
    formattedCommerce: {
      get() {
        return this.userData.income.commerce
      },
      set(value) {
        this.userData.income.commerce = parseFloat(value) || 0
      }
    },
    formattedCapital: {
      get() {
        return this.userData.income.capital
      },
      set(value) {
        this.userData.income.capital = parseFloat(value) || 0
      }
    },
    formattedIndependentWork: {
      get() {
        return this.userData.income.independentWork
      },
      set(value) {
        this.userData.income.independentWork = parseFloat(value) || 0
      }
    },
    formattedRent: {
      get() {
        return this.userData.income.rent
      },
      set(value) {
        this.userData.income.rent = parseFloat(value) || 0
      }
    },
    formattedOther: {
      get() {
        return this.userData.income.other
      },
      set(value) {
        this.userData.income.other = parseFloat(value) || 0
      }
    },
    //Calculate sum of all incomes
    sumOfIncome: function () {
      const obj = this.userData.income;
      let sum = 0;

      Object.keys(obj).forEach(function (key) {
        sum = sum + obj[key];
      });

      return sum;
    },
    sumOfFreeAmounts: function () {
      return this.calcSumOfFreeAmounts(this.userData.freeAmounts2021, false)
    },
    //Calculate free amounts related to user inputs
    werbungskosten: {
      get() {
        if (this.checkCashSplitting()) {
          return this.freeAmounts2021.werbungskosten * 2
        } else {
          return this.freeAmounts2021.werbungskosten
        }
      },
      set(value) {
        if (this.checkCashSplitting()) {
          this.freeAmounts2021.werbungskosten = (parseFloat(value) / 2) || 0
        } else {
          this.freeAmounts2021.werbungskosten = parseFloat(value) || 0
        }
        this.userData.freeAmounts2021.werbungskosten = parseFloat(value) || 0
      }
    },
    entlastungAlleinerziehend: {
      get() {
        if (this.userData.hasKids && this.userData.isSingleParent) { //Kinder + alleinerziehend
          // //Berechne Anzahl der Kinder
          // //Annahme: Alleinerziehende bekommen ebenfalls halben Kinderfreibetrag (trifft nur bei Sonderbed nicht zu)
          // const sumOfKids = this.userData.kidsFreeAmount * 2;
          // return this.freeAmounts2021.entlastungAlleinerziehend + (240 * (sumOfKids - 1));

          return this.freeAmounts2021.entlastungAlleinerziehend + (240 * (this.userData.sumOfKids - 1));
        } else { //keine Kinder oder nicht alleinerziehend
          return 0;
        }
      },
      set(value) {
        if (this.userData.hasKids && this.userData.isSingleParent) { //Kinder + alleinerziehend
          // //Berechne Anzahl der Kinder
          // //Annahme: Alleinerziehende bekommen ebenfalls halben Kinderfreibetrag (trifft nur bei Sonderbed nicht zu)
          // const sumOfKids = this.userData.kidsFreeAmount * 2;
          // this.freeAmounts2021.entlastungAlleinerziehend = (parseFloat(value) - (240 * (sumOfKids - 1))) || 0;

          this.freeAmounts2021.entlastungAlleinerziehend = (parseFloat(value) - (240 * (this.userData.sumOfKids - 1))) || 0;
        } else { //keine Kinder oder nicht alleinerziehend
          this.freeAmounts2021.entlastungAlleinerziehend = 0;
        }
        this.userData.freeAmounts2021.entlastungAlleinerziehend = parseFloat(value) || 0
      }
    },
    ausbildungsfreibetrag: {
      get() {
        return this.calcAusbildungsfreibetrag(this.freeAmounts2021.ausbildungsfreibetrag);
      },
      set(value) {
        if (this.userData.hasKids) {
          if (this.checkCashSplitting()) {  //verheiratet + zusammen veranlagt
            this.freeAmounts2021.ausbildungsfreibetrag = parseFloat(value) || 0
          } else {
            this.freeAmounts2021.ausbildungsfreibetrag = (parseFloat(value) * 2) || 0
          }
        }
        this.userData.freeAmounts2021.ausbildungsfreibetrag = parseFloat(value) || 0
      }
    },
    entfernungspauschale: {
      get() {
        return this.freeAmounts2021.entfernungspauschale
      },
      set(value) {
        this.freeAmounts2021.entfernungspauschale = parseFloat(value) || 0;
        this.userData.freeAmounts2021.entfernungspauschale = parseFloat(value) || 0;
        this.userData.freeAmounts2020.entfernungspauschale = parseFloat(value) || 0;
      }
    },
    umzugskostenpauschale: {
      get() {
        return this.calcUmzugskostenpauschale(this.freeAmounts2021.umzugskostenpauschale);
      },
      set(value) {
        if (this.checkCashSplitting()) {  //verheiratet + zusammen veranlagt
          this.freeAmounts2021.umzugskostenpauschale = (parseFloat(value) / 2) || 0
        } else {
          this.freeAmounts2021.umzugskostenpauschale = parseFloat(value) || 0
        }

        this.userData.freeAmounts2021.umzugskostenpauschale = parseFloat(value) || 0
      }
    },
    uebungsleiterfreibetrag: {
      get() {
        return this.freeAmounts2021.uebungsleiterfreibetrag
      },
      set(value) {
        this.freeAmounts2021.uebungsleiterfreibetrag = parseFloat(value) || 0;
        this.userData.freeAmounts2021.uebungsleiterfreibetrag = parseFloat(value) || 0;
      }
    },
    homeOffice: {
      get() {
        return this.freeAmounts2021.homeOffice
      },
      set(value) {
        this.freeAmounts2021.homeOffice = parseFloat(value) || 0;
        this.userData.freeAmounts2021.homeOffice = parseFloat(value) || 0;
      }
    },
    ehrenamtsfreibetrag: {
      get() {
        return this.freeAmounts2021.ehrenamtsfreibetrag
      },
      set(value) {
        this.freeAmounts2021.ehrenamtsfreibetrag = parseFloat(value) || 0;
        this.userData.freeAmounts2021.ehrenamtsfreibetrag = parseFloat(value) || 0;
      }
    },
    pflegepauschbetrag: {
      get() {
        return this.freeAmounts2021.pflegepauschbetrag
      },
      set(value) {
        this.freeAmounts2021.pflegepauschbetrag = parseFloat(value) || 0;
        this.userData.freeAmounts2021.pflegepauschbetrag = parseFloat(value) || 0;
      }
    },
    hinterbliebene: {
      get() {
        return this.freeAmounts2021.hinterbliebene
      },
      set(value) {
        this.freeAmounts2021.hinterbliebene = parseFloat(value) || 0;
        this.userData.freeAmounts2021.hinterbliebene = parseFloat(value) || 0;
      }
    },
    altersentlastungsbetrag: {
      get() {
        return this.freeAmounts2021.altersentlastungsbetrag
      },
      set(value) {
        this.freeAmounts2021.altersentlastungsbetrag = parseFloat(value) || 0;
        this.userData.freeAmounts2021.altersentlastungsbetrag = parseFloat(value) || 0;
        this.userData.freeAmounts2020.altersentlastungsbetrag = parseFloat(value) || 0;
      }
    },
    sonstiges: {
      get() {
        return this.freeAmounts2021.sonstiges
      },
      set(value) {
        this.freeAmounts2021.sonstiges = parseFloat(value) || 0;
        this.userData.freeAmounts2021.sonstiges = parseFloat(value) || 0;
        this.userData.freeAmounts2020.sonstiges = parseFloat(value) || 0;
      }
    },

    sumOfExpenses: function () {
      return this.calcSumOfExpanses(this.freeAmounts2021, false)
    },
    //Dropdown menus
    showFreeAmountDropdown: function () {
      return !(
        this.showEntfernungspauschale &&
        this.showUmzugskostenpauschale &&
        this.showUebungsleiterfreibetrag &&
        this.showHomeOfficePauschale &&
        this.showEhrenamtsfreibetrag &&
        this.showPflegepauschbetrag &&
        this.showHinterbliebenenpauschbetrag &&
        this.showAltersentlastungsbetrag &&
        this.showSonstige);
    },
    showIncomeDropdown: function () {
      return !(this.showIncomeAgrarInput &&
        this.showIncomeCommerceInput &&
        this.showIncomeIndependentWorkInput &&
        this.showIncomeCapitalInput &&
        this.showIncomeRentInput &&
        this.showIncomeOtherInput);
    },
    //Aufwendungen
    additionalHealthContribution: {//Zusatzbeitrag gesetzliche KV
      get() {
        return this.userData.expenses.additionalHealthContribution
      },
      set(value) {
        this.userData.expenses.additionalHealthContribution = parseFloat(value) || 0;
      }
    },
    privatHealthContribution: {//Beitrag private KV
      get() {
        return this.userData.expenses.privatHealthContribution
      },
      set(value) {
        this.userData.expenses.privatHealthContribution = parseFloat(value) || 0;
      }
    },
    additionalPrecaution: { //Weitere Vorsorgeaufwendungen
      get() {
        return this.userData.expenses.additionalPrecaution
      },
      set(value) {
        this.userData.expenses.additionalPrecaution = parseFloat(value) || 0;
      }
    },
    specialExpenses: { //Sonderausgaben
      get() {
        return this.userData.expenses.specialExpenses
      },
      set(value) {
        this.userData.expenses.specialExpenses = parseFloat(value) || 0;
      }
    }
  },
  filters: {
    numberFormat: function (value) {
      console.log(value)
      if (value > 0) {
        const number = parseFloat(value);
        // return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number)
        return number.toLocaleString() + ' €'
      } else if (value === 0) {
        return 0 + ' €'
      } else {
        return value
      }
    }
  }
}
</script>

<style lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100vw;

  @include lg {
    flex-direction: row;
  }


  &__content {
    width: 100vw;
    height: 77vh;
    height: calc(var(--vh, 1vh) * 77);
    //height: auto;
    //min-height: 669px;
    //max-height: 730px;
    padding: 2rem 2rem .5rem 2rem;
    display: flex;
    flex-flow: column nowrap;
    overflow: auto;
    margin-bottom: 1rem;

    @include sm {
      padding: 2rem;
    }

    @include md {
      padding: 6rem 4rem 0 4rem;
    }

    @include lg {
      margin-bottom: 0;
      width: calc(100vw - 300px);
      padding: 3rem 3rem 0 3rem;
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      //height: auto;
      //min-height: 650px;
      //max-height: 730px;
    }

    @include rwd(992) {
      width: calc(100vw - 400px);
      //height: auto;
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      padding: 6rem 4rem 2rem 5rem;
    }

    @include rwd(1400) {
      width: calc(100vw - 500px);
      padding: 6rem 6rem 2rem 6rem;
    }

  }

  &__sidebar {
    position: relative;
    padding: .5rem;
    width: 100vw;
    height: 23vh;
    height: calc(var(--vh, 1vh) * 23);
    //height: auto;
    //min-height: 170px;
    background: $primary-background;
    display: flex;
    flex-direction: column;
    justify-content: center;

    // 576px window width and more
    @include sm {
    }
    // 992px window width and more
    @include lg {
      width: 300px;
      height: auto;
      padding: 10rem 0 0.5rem 0;
    }

    @include rwd(992) {
      width: 400px;
      height: auto;
      padding: 10rem 0.5rem 0.5rem 0.5rem;
    }

    // 1400px window width and more
    @include rwd(1400) {
      padding: 10rem 1.5rem 1.5rem 1.5rem;
      width: 500px;
    }
  }
}

.showTestData {
  font-size: .75rem;
  line-height: 1rem;
}

.result {
  @include lg {
    display: inline-block;
    line-height: 1.25rem;
  }
}

.zwischenergebnis {
  margin-top: 0;
  margin: auto 0;

  @include lg {
    margin-top: 7rem;
  }
}

.ergebnis {

}



</style>
